import { useContext, useRef } from 'react';

import { useSelector } from 'react-redux';

import StickyHeader from 'components/Layouts/Admin/Dashboard/StickyHeader';
import MediaBlocks from 'components/Pages/FileLibrary/Common/MediaBlocks';
import Context from 'components/Pages/FileLibrary/context';
import GlobalSearchInput from 'components/shared/GlobalSearchInput';
import PlusCircle from 'components/shared/Icon/icons/PlusCircle';
import Loader from 'components/shared/Loader';
import PageHeader from 'components/shared/PageHeader';
import { ASSET_LIBRARY_OWNERSHIP_OPTIONS } from 'constants/assetsLibrary';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import { searchFiltersSelector } from 'store/admin/files/selectors';
import { isSuperAdminSelector, isAgentSelector } from 'store/user/selectors';

import MediaFilterButton from '../Filter';
import s from './common.module.css';

const CommonLibrary = () => {
  const scrollableContainerRef = useRef(null);
  const context = useContext(Context);
  const isSuperAdmin = useSelector(isSuperAdminSelector);
  const isAgent = useSelector(isAgentSelector);
  const { media } = useSelector(searchFiltersSelector);
  const { isTabletOrMobile } = useMediaBreakpoints();

  const assets = context.assets && (context.assets[0]?.type === context.module ? context.assets : []);
  const showOwnership = (context.module === 'media' && isSuperAdmin) || context.module === 'document';

  return (
    <StickyHeader ref={scrollableContainerRef}>
      <PageHeader
        title={context.title}
        field={
          <GlobalSearchInput
            value={context.search}
            placeholder={`Search ${context.module} library...`}
            onChange={(v) => context.onSearchType(v)}
            onClear={() => context.onSearchType('')}
            onSubmit={() => {}}
            isLoading={context.isGlobalLoader}
          />
        }
        ownership={
          showOwnership &&
          !isAgent && {
            module: context.module,
            options: ASSET_LIBRARY_OWNERSHIP_OPTIONS[context.module],
          }
        }
        button={
          <>
            {context.module === 'media' && isAgent && (
              <MediaFilterButton
                filter={media}
                filterName="Media Library"
                filterKeyName="media"
                type="media"
                buttonName="Set Filters"
                isMobile={isTabletOrMobile}
                className={s.filter}
              />
            )}
            <PageHeader.Button onClick={() => context.onOpenModal()} icon={PlusCircle}>
              {context.buttonText}
            </PageHeader.Button>
          </>
        }
      />
      <>
        {Boolean(assets && !context.isGlobalLoader) && (
          <MediaBlocks
            assets={assets}
            onLoadChunk={() => context.onLoadChunk(false)}
            onClick={(asset) => context.onSelectFile(asset)}
            onDelete={(asset) => context.onDelete(asset)}
            onCheckUpdatable={(asset) => asset?.policies?.update || asset?.policies?.destroy}
            placeholder={context.placeholder}
            scrollableContainerRef={scrollableContainerRef}
          />
        )}
        {context.isGlobalLoader && <Loader isFillBlock transparent />}
      </>
    </StickyHeader>
  );
};

export default CommonLibrary;
